module.exports = __webpack_public_path__ + "img/blog-details.ddad021f.jpg";